"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AssetRegistry_1 = require("@dialogexe/cw-asset-provider/core/AssetRegistry");
AssetRegistry_1.default.register('kinoklubb-black', require('./img/kinoklubb-black.png'));
AssetRegistry_1.default.register('eblogo', require('./img/eblogo.png'));
AssetRegistry_1.default.register('app-store', require('./img/app-store.png'));
AssetRegistry_1.default.register('google-play', require('./img/google-play.png'));
AssetRegistry_1.default.register('filmGrail', require('./img/filmgrail.png'));
AssetRegistry_1.default.register('fredrikstadkino', require('./img/fredrikstadkino.png'));
AssetRegistry_1.default.register('landscapeImagePlaceholder', require('./img/landscapeImagePlaceholder.png'));



// WEBPACK FOOTER //
// ./src/layouts/assets/images.ts